/**
 * @generated SignedSource<<6b227c439114df3120ed229bd8a9857a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "webhookService",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "completeCompleteImplWebhookServiceQuery",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "completeCompleteImplWebhookServiceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d298e2089f639842bd648c7a0f272f75",
    "id": null,
    "metadata": {},
    "name": "completeCompleteImplWebhookServiceQuery",
    "operationKind": "mutation",
    "text": "mutation completeCompleteImplWebhookServiceQuery(\n  $request: WebhookServiceRequestInput\n) {\n  webhookService(request: $request) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "1241214f64c45a38b6cc82fe64e683ce";

module.exports = node;
